var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailgatingIconGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "66px",
    height: "35px",
    viewBox: "0 0 66 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/tailgate/tailgate (MDC dasgboard)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/tailgate/tailgate-(MDC-dasgboard)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/trailer_grey",
    transform: "translate(0.234899, 13.154362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.108871,0 L26.108871,16.8955376 L22.1174185,16.8958345 C21.5058567,15.0077549 19.7329322,13.6424731 17.641129,13.6424731 C15.7790678,13.6424731 14.169687,14.724327 13.4072531,16.2937684 C12.6455182,14.7247903 11.035847,13.6424731 9.1733871,13.6424731 C7.08158395,13.6424731 5.30865945,15.0077549 4.69709766,16.8958345 L7.96877498e-13,16.8955376 L7.96877498e-13,0 L26.108871,0 Z",
    id: "Combined-Shape",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#BCBCBC",
    strokeWidth: 1.6442953,
    cx: 9.1733871,
    cy: 18.3467742,
    r: 2.70607816
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#BCBCBC",
    strokeWidth: 1.6442953,
    cx: 17.641129,
    cy: 18.3467742,
    r: 2.70607816
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.9752456,12.2857143 L29.4849723,12.2857143 L29.2109231,0.469798658 L32.26121,0.469798658 L31.9752456,12.2857143 Z M29.1275168,15.8983701 C29.1275168,15.4611675 29.2744692,15.098755 29.5683786,14.8111218 C29.8622879,14.5234885 30.2634284,14.379674 30.7718121,14.379674 C31.2801958,14.379674 31.6813363,14.5234885 31.9752456,14.8111218 C32.2691549,15.098755 32.4161074,15.4611675 32.4161074,15.8983701 C32.4161074,16.3202322 32.2731266,16.6730571 31.9871608,16.9568552 C31.701195,17.2406534 31.2960828,17.3825503 30.7718121,17.3825503 C30.2475414,17.3825503 29.8424292,17.2406534 29.5564634,16.9568552 C29.2704975,16.6730571 29.1275168,16.3202322 29.1275168,15.8983701 Z",
    id: "!",
    fill: "#EB3C39",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_black",
    transform: "translate(28.000000, 13.125000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#BCBCBC",
    strokeWidth: 1.64650538,
    cx: 26.344086,
    cy: 18.3467742,
    r: 2.70497312
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    stroke: "#BCBCBC",
    strokeWidth: 1.64650538,
    cx: 5.88037634,
    cy: 18.3467742,
    r: 2.70497312
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    stroke: "#BCBCBC",
    strokeWidth: 1.64650538,
    cx: 33.8709677,
    cy: 18.3467742,
    r: 2.70497312
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.110777,14.8185484 L31.1044663,14.8185484 C30.9398269,14.9148922 30.7744368,15.0461345 30.608296,15.2122753 C30.4421553,15.378416 30.2752638,15.5794553 30.1076216,15.815393 C29.9429823,15.5794553 29.7775922,15.378416 29.6114514,15.2122753 C29.4453106,15.0461345 29.2784192,14.9148922 29.110777,14.8185484 Z",
    id: "Path-3",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6989247,0.235215054 C20.746506,0.0784050179 20.824911,0 20.9341398,0 C21.0433686,0 21.1217736,0.0784050179 21.1693548,0.235215054 L21.4045699,0.705645161 L21.4045699,6.69623698 C21.4045699,6.77439454 21.4433921,6.8474474 21.5081684,6.89118111 L22.0066165,7.22770833 C22.0713928,7.27144204 22.1102151,7.34449489 22.1102151,7.42265246 L22.1102151,13.4072581 L22.1102151,13.4072581 L21.6668364,13.8776882 L20.9341398,13.8776882 L20.1930085,13.8776882 L19.7580645,13.4072581 L19.7580645,7.44513301 C19.7580645,7.36906294 19.7948529,7.29768934 19.8568107,7.25355441 L20.3649635,6.89157729 C20.4269213,6.84744237 20.4637097,6.77606876 20.4637097,6.6999987 L20.4637097,0.705645161 L20.4637097,0.705645161 L20.6989247,0.235215054 Z",
    id: "Rectangle",
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.522,0.705645161 L19.5228495,14.8185484 L22.814,14.8176452 L22.8146753,15.6049076 C22.225742,16.3619092 21.875,17.3133816 21.875,18.3467742 L10.3494624,18.3467742 C10.3494624,15.8785661 8.3485844,13.8776882 5.88037634,13.8776882 C3.41216829,13.8776882 1.41129032,15.8785661 1.41129032,18.3467742 L1.01954035e-12,18.3467742 L-0.00167331429,11.473094 C0.133930121,11.3292513 0.337789028,11.2063808 0.609903408,11.1044825 L0.781362692,11.0458602 L8.46774194,10.5846774 L8.46774535,6.39575092 C8.63288185,6.05216787 8.86809576,5.88037634 9.1733871,5.88037634 L11.0551075,5.88037634 L11.0551075,5.88037634 C11.4918406,3.15021918 13.3763392,1.42483222 16.7086033,0.704215455 L19.522,0.705645161 Z M12.7016129,6.82123656 L9.87903226,6.82123656 C9.64808881,6.82123656 9.45601363,6.98765136 9.41618141,7.20710626 L9.40860215,7.29166667 L9.40860215,10.1142473 C9.40860215,10.3451908 9.57501695,10.5372659 9.79447185,10.5770982 L9.87903226,10.5846774 L12.7016129,10.5846774 C12.9325563,10.5846774 13.1246315,10.4182626 13.1644638,10.1988077 L13.172043,10.1142473 L13.172043,7.29166667 C13.172043,7.03185529 12.9614243,6.82123656 12.7016129,6.82123656 Z",
    id: "Combined-Shape",
    fill: "#BCBCBC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailgatingIconGrey);
export default __webpack_public_path__ + "static/media/tailgating_icon_grey.c32000bedb87b1d5a7fa9e10acb0649e.svg";
export { ForwardRef as ReactComponent };